import React, { useContext, useState } from 'react'
import './cfo.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { ShareContext } from '../../context/ShareContext'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import { time } from '../../data/time'
import BackLoader from '../../components/backloader'

function CfoTable() {


    const { setSweared, setIsCfo } = useContext(ShareContext)

    const [isDialog, setIsDialog] = useState(false)
    const [isLoading,setIsLoading]= useState(false);

    const openSchedule = () => {
        setIsDialog(true)
    }


    const schedule = [
        {
            id: 0,
            docTitle: 'Statement of Compliance with pre-action protocol',
            fileId: 234,
            isScheduled: true,
            dateAndTime: '2023-12-27   10:00 AM GMT',
            zoom: 'https://www.zoom.com/meetingId?=s8828dc/0?'
        },
        {
            id: 1,
            docTitle: 'Statement of Compliance with pre-action protocol',
            fileId: 234,
            isScheduled: false,
            dateAndTime: '',
            zoom: ''
        },
        {
            id: 2,
            docTitle: 'Statement of Compliance with pre-action protocol',
            fileId: 234,
            isScheduled: false,
            dateAndTime: '',
            zoom: ''
        },
        {
            id: 3,
            docTitle: 'Statement of Compliance with pre-action protocol',
            fileId: 234,
            isScheduled: true,
            dateAndTime: '2023-12-27   10:00 AM GMT',
            zoom: 'https://www.zoom.com/meetingId?=s8828dc/0?'
        },
        {
            id: 4,
            docTitle: 'Statement of Compliance with pre-action protocol',
            fileId: 234,
            isScheduled: false,
            dateAndTime: '',
            zoom: ''
        },
        {
            id: 5,
            docTitle: 'Statement of Compliance with pre-action protocol',
            fileId: 234,
            isScheduled: true,
            dateAndTime: '2023-12-27   10:00 AM GMT',
            zoom: 'https://www.zoom.com/meetingId?=s8828dc/0?'
        }
    ]

    function zoomSet (){
        setSweared(true)
        setIsCfo(true)
    }

  return (
    <div className='cfo-view'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>e-Swearing Schedule</h2>
                    </div>
                    <p>Re-schedule and view e-Swearing Meetings</p>
                </div>
                <p className="nav-status">Home/e-Swearing-Schedule</p>
            </div>
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Document Title</th>
                            <th>File ID</th>
                            <th>Schedule Date and Time</th>
                            <th>Zoom Link</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { schedule.map((item, id) => { return (
                            <tr key={id}>
                                <td>{item.docTitle}</td>
                                <td>{item.fileId}</td>
                                <td className={ item.isScheduled ?'date-time' : 'date-time pends'}>{item.isScheduled ? item.dateAndTime : 'Pending'}</td>
                                <td className={item.isScheduled ? 'zoom' : 'zoom pends'}>{item.isScheduled ? item.zoom : 'Pending'}</td>
                                <td className='view-doc'>
                                    <Link to='/view-document' onClick={() => zoomSet()}>View</Link>
                                    <button className='black' onClick={() => openSchedule()}>{item.isScheduled ? 'Re-Schedule' : 'Schedule'}</button>
                                </td>
                            </tr>
                        )})}
                    </tbody>
                </table>
            </div>
        </div>
        <div className={isDialog ? 'dialog open' : 'dialog'}>
            <div className="container">
                <div className="icon" onClick={() => setIsDialog(false)}>
                    <FontAwesomeIcon icon={faClose} />
                </div>
                <div className="body">
                    <h3>Schedule</h3>
                    <div className="form">
                        <div className="input">
                            <label htmlFor="zoom-link">Please input the zoom link:</label>
                            <input type="text" id='zoom-link' />
                        </div>
                        <div className="inputs">
                            <div className="input">
                                <label htmlFor="zoom-date">Scheduled Date</label>
                                <input type="date" id="zoom-date" />
                            </div>
                            <div className="input">
                                <label htmlFor="zoom-time">Scheduled Time</label>
                                <select id="zoom-time">
                                    <option value="" disabled>Select Time</option>
                                    {
                                        time.map((item, id) => {return (
                                            <option key={id} value={item.value}>{item.time}</option>
                                        )})
                                    }
                                </select>
                            </div>
                        </div>
                        <button type='submit' className='schedule'>Schedule</button>
                    </div>
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
    </div>
  )
}

export default CfoTable